<div class="auth-page">
  <div class="auth-card">
    <div class="auth-left">
      <div class="auth-left-content">
        <div class="auth-header">
          <img
            class="auth-logo"
            src="/assets/images/logo/logo-hudlygo.png"
            alt="Hudly.go Seguros &amp; Benefícios"
          />

          <h1 class="auth-title">
            Acesse o seu<br />
            Escritório de Seguros
          </h1>
        </div>

        <app-login-form [unsub]="unsubscribe$"></app-login-form>
      </div>
    </div>

    <div class="auth-right" *ngIf="!isPhone">
      <div class="auth-right-inner">
        <div class="auth-right-overlay"></div>
        <img
          class="auth-right-bg"
          src="/assets/images/login-bg.png"
          alt="Background"
        />
      </div>
    </div>
  </div>
</div>
